// extracted by mini-css-extract-plugin
export default {"epmty_info":"EmptyCart_epmty_info__s6Pc-","empty_title":"EmptyCart_empty_title__qtib8"};